import { Button, Grid, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import AddIcon from '@mui/icons-material/Add';
import SelectWithSerch from './SelectWithSearch/SelectWithSerch';
import { SelectedOptionContext } from '../Context/SelectedOptionContext';
import FormSettingSelect from './FormSettingSelect';
import PassOption from './PassOption';
import { useLocation, useNavigate } from 'react-router-dom';
import { PayloadContext } from '../Context/PayloadContext';
import { SelectValuesContext } from '../Context/SelectValuesContext';
import { FinalValuesContext } from '../Context/FinalValuesContext';
import ThankYouInitialContentContext from '../Context/ThankYouInitialContentContext';
import FilteredValuesContext from '../Context/FilteredValuesContext';
import ThankYouConditionEditor from './ThankYouConditionEditor/ThankYouConditionEditor';
import Calculator from './Calculator/Calculator';
import { defaultValues, doOption, doOptionEmail, doOptionEnableAndRequire, doOptionSkip, doOptionThankYou, doOptionUpdateAndCalculate, pageOption, targetStatus } from '../Constant/Condition';
import axios from 'axios';
import CustomToast from './CustomToast/CustomToast';
import { toast } from 'react-toastify';
import { useActionTypeFromUrl } from '../hooks/useActionTypeFromUrl';
import { useLoading } from '../Context/LoadingContext';
import { useSearchParams } from 'react-router-dom';


const Condition = ({ flag, color, fieldFlag, value, placeholder, emialFlag, options, mbFlag }) => {


    let FormId = localStorage.getItem('createFormId')

    const { setLoading } = useLoading()


    const location = useLocation();
    const currentPage = location.pathname;
    const navigate = useNavigate()
    const [searchParams] = useSearchParams();
    const status = searchParams.get('status');

    const { selectedOption } = useContext(SelectedOptionContext);
    const { payload } = useContext(PayloadContext);
    const { selectValues, setSelectValues } = useContext(SelectValuesContext);
    const { filteredSelectValuesList, setFilteredSelectValuesList } = useContext(FilteredValuesContext);

    const actionType = useActionTypeFromUrl();

    const [conditionValue, setConditionValue] = useState("");
    const peTitle = [];
    const [updateTitle, setUpdateTitle] = useState([]);
    const [filterTitle, setFilterTitle] = useState([])
    const [filterPassTitle, setFilterPassTitle] = useState([])
    const [show, setShow] = useState(true);
    const [urlValue, setUrlValue] = useState('')
    const [emailValue, setEmailValue] = useState('')
    const [showTarget, setShowTarget] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');


    function checkCondition(value) {
        return value === "پنهان کردن چندگانه" ||
            value === "نمایش چندگانه" ||
            value === "نیاز به چندین گزینه" ||
            value === "نیاز به چندین گزینه نداشته باشید";
    }

    let condition = checkCondition(selectValues[18].value) ||
        checkCondition(selectValues[19].value) ||
        checkCondition(selectValues[20].value) ||
        checkCondition(selectValues[21].value) ||
        checkCondition(selectValues[22].value) ||
        checkCondition(selectValues[23].value);


    let marginCondition = selectValues[1].value === 'پر شده است' || selectValues[1].value === 'خالی است' ? '0px' : '20px'

    let doIndex = selectValues.findIndex(item => item.name.includes("DoCondition") && item.value !== '')

    let DoConditionUpdateAndCalculateIndex = selectValues.findIndex(item => item.name === "DoConditionUpdateAndCalculate")

    const renderView = () => {
        if (currentPage.includes('/setting/conditional/show-and-hide')) {
            return doOption;
        } else if (currentPage.includes('/setting/conditional/update-calculate')) {
            return doOptionUpdateAndCalculate;
        } else if (currentPage.includes('/setting/conditional/enable-require')) {
            return doOptionEnableAndRequire;
        } else if (currentPage.includes('/setting/conditional/skip')) {
            return doOptionSkip;
        } else if (currentPage.includes('/setting/conditional/thankyou')) {
            return doOptionThankYou;
        } else if (currentPage.includes('/setting/conditional/email-recipient')) {
            return doOptionEmail;
        } else {
            return doOption;
        }
    };



    const handleChangeValue = (e, name) => {
        setConditionValue(e.target.value)
        setSelectValues((prevSelectValues) =>
            prevSelectValues.map((select) =>
                select.name === name ? { ...select, value: conditionValue } : select
            )
        );
    };


    const handleChangeUrlValue = (e) => {
        const newValue = e.target.value;
        if (!newValue.startsWith('https://')) {
            setErrorMessage('آدرس اینترنتی باید با "https://" شروع شود');
        } else {
            setErrorMessage('');
        }
        setUrlValue(e.target.value)

        setSelectValues((prevSelectValues) =>
            prevSelectValues.map((select) =>
                select.name === 'urlValue' ? { ...select, value: urlValue } : select
            )
        );
    };



    const handleChangeEmailValue = (e) => {
        setEmailValue(e.target.value)
        setSelectValues((prevSelectValues) =>
            prevSelectValues.map((select) =>
                select.name === 'emailValue' ? { ...select, value: emailValue } : select
            )
        );
    };


    const handleSelectChange = (name, value) => {

        // Check if a select with the given name already exists in the array
        const existingIndex = selectValues.findIndex((select) => select.name === name);

        if (existingIndex !== -1) {
            // If a select with the given name exists, update its value
            const updatedSelects = [...selectValues];
            updatedSelects[existingIndex] = { ...updatedSelects[existingIndex], value };
            setSelectValues(updatedSelects);
        } else {
            // If a select with the given name doesn't exist, add it to the array
            setSelectValues((prevSelectValues) => [...prevSelectValues, { name, value }]);
        }
    };


    const handleChangePeTitle = () => {
        options.map(
            item =>
                peTitle.push({ value: item.peTitle, label: item.peTitle })
        )
    }


    const handleFilterTitle = () => {
        let index = options.findIndex(title => title.peTitle === selectValues[0].value)
        const filter = [...options]
        filter.splice(index, 1)
        setFilterTitle(filter)
        setFilterPassTitle(
            filter.map(
                item => ({ value: item.peTitle, label: item.peTitle })
            )
        )
    }


    const handleShowTarget = () => {

        let index;

        let targetIndex;

        if (currentPage.includes('/setting/conditional/show-and-hide')) {

            index = selectValues.findIndex(item => item.name === 'StateCondition')
            targetIndex = selectValues.findIndex(item => item.name === "TargetStatus")

        } else if (currentPage.includes('/setting/conditional/update-calculate')) {

            index = selectValues.findIndex(item => item.name === "StateConditionUpdateAndCalculate")
            targetIndex = selectValues.findIndex(item => item.name === "TargetStatusUpdateAndCalculate")

        } else if (currentPage.includes('/setting/conditional/enable-require')) {

            index = selectValues.findIndex(item => item.name === "StateConditionEnableAndRequire")
            targetIndex = selectValues.findIndex(item => item.name === "TargetStatusEnableAndRequire")

        } else if (currentPage.includes('/setting/conditional/thankyou')) {

            index = selectValues.findIndex(item => item.name === "StateConditionThankYou")
            targetIndex = selectValues.findIndex(item => item.name === "TargetStatusThankYou")

        } else if (currentPage.includes('/setting/conditional/skip')) {

            index = selectValues.findIndex(item => item.name === "StateConditionSkip")
            targetIndex = selectValues.findIndex(item => item.name === "TargetStatusSkip")

        } else if (currentPage.includes('/setting/conditional/email-recipient')) {

            index = selectValues.findIndex(item => item.name === "StateConditionEmail")
            targetIndex = selectValues.findIndex(item => item.name === "TargetStatusEmail")

        }

        if (selectValues[index]?.value === 'خالی است' || selectValues[index]?.value === 'پر شده است') {
            setShow(false)
        } else {
            setShow(true)
        }

        if (selectValues[targetIndex]?.value === 'یک فیلد دیگر') {
            setShowTarget(false)
        } else {
            setShowTarget(true)
        }
    }






    const handleCreateCondition = async () => {

        const token = localStorage.getItem('authToken');

        const filteredSelectValues = selectValues.filter(item => item.value !== '' && item.value !== null);


        let finalConditions = {
            formId: FormId,
            content: JSON.stringify(filteredSelectValues),
            type: actionType
        }

        axios.post(`https://formmaker-api.altynlogistics.com/api/conditions`, finalConditions, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setFilteredSelectValuesList(prevList => [...prevList, filteredSelectValues]);
            toast(<CustomToast message="شرط با موفقیت ساخته شد" state={'success'} />)
            navigate(`/setting/condition-list/${FormId}`)
        }).catch((error) => {
            console.error('Error sending data to the server:', error);
        });


    };


    const handleUpdateCondition = (index, id) => {

        const token = localStorage.getItem('authToken');

        setLoading(true)

        const filteredSelectValues = selectValues.filter(item => item.value !== '' && item.value !== null);


        let finalConditions = {
            content: JSON.stringify(filteredSelectValues),
        }

        axios.patch(`https://formmaker-api.altynlogistics.com/api/conditions/${id}`, finalConditions, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
            .then((response) => {
                setFilteredSelectValuesList(newList);
                toast(<CustomToast message="شرط با موفقیت به روزرسانی شد" state={'success'} />);
                navigate(`/setting/condition-list/${FormId}`)
                setLoading(false)
            })
            .catch((error) => {
                toast(<CustomToast message="به روزرسانی شرط موفقیت آمیز نبود" state={'error'} />);
                setLoading(false)
            });

        const newList = filteredSelectValuesList.filter((_, i) => i !== index);

    };


    const handleSaveCondition = () => {
        if (status === 'update') {
            const conditionId = searchParams.get('condition_id');
            const index = searchParams.get('index');
            handleUpdateCondition(index, conditionId);
        } else {
            handleCreateCondition();
        }
    };


    useEffect(() => {
        handleChangePeTitle()
        let updateState = peTitle.slice(0, peTitle.length / 2)
        setUpdateTitle(updateState)
    }, [options])


    useEffect(() => {
        handleFilterTitle()
        handleShowTarget()
    }, [selectValues])


    useEffect(() => {

        if (currentPage.includes('/setting/conditional/show-and-hide')) {

            setSelectValues(prevSelectValues =>
                prevSelectValues.map(select =>
                    select.name === 'ifCondition' ? { ...select, value: selectedOption } : select
                )
            );

        } else if (currentPage.includes('/setting/conditional/update-calculate')) {

            setSelectValues(prevSelectValues =>
                prevSelectValues.map(select =>
                    select.name === 'ifConditionUpdateAndCalculate' ? { ...select, value: selectedOption } : select
                )
            );

        } else if (currentPage.includes('/setting/conditional/enable-require')) {

            setSelectValues(prevSelectValues =>
                prevSelectValues.map(select =>
                    select.name === 'ifConditionEnableAndRequire' ? { ...select, value: selectedOption } : select
                )
            );

        } else if (currentPage.includes('/setting/conditional/thankyou')) {

            setSelectValues(prevSelectValues =>
                prevSelectValues.map(select =>
                    select.name === 'ifConditionThankYou' ? { ...select, value: selectedOption } : select
                )
            );

        } else if (currentPage.includes('/setting/conditional/skip')) {

            setSelectValues(prevSelectValues =>
                prevSelectValues.map(select =>
                    select.name === 'ifConditionSkip' ? { ...select, value: selectedOption } : select
                )
            );

        } else if (currentPage.includes('/setting/conditional/email-recipient')) {

            setSelectValues(prevSelectValues =>
                prevSelectValues.map(select =>
                    select.name === 'ifConditionEmail' ? { ...select, value: selectedOption } : select
                )
            );

        }


    }, [selectedOption]);



    useEffect(() => {
        if (!currentPage.includes('/setting/conditional')) {
            setSelectValues(prevSelectValues =>
                prevSelectValues.map(select =>
                    select.name === 'editorValue' ? { ...select, value: payload } : select
                )
            );
        }

    }, [payload]);


    useEffect(() => {
        setSelectValues(defaultValues)
    }, [currentPage])




    return (
        <Grid width={'100%'}>
            <Grid className='MobileShowAndHideCondition' display={{ xs: 'block', xxs: 'none' }}>
                <Grid className='IF' mb={'16px'}>
                    <Grid mb={'8px'} width={'32px'} height={'32px'} borderRadius={'4px'} bgcolor={'#0075e3'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                        <AddIcon style={{ color: 'white' }} fontSize='large' />
                    </Grid>
                    <Grid width={'100%'} p={'24px 16px'} bgcolor={'white'} borderRight={`7px solid ${color}`} borderTop={'1px solid #c8ceed'} borderLeft={'1px solid #c8ceed'} borderBottom={'1px solid #c8ceed'} borderRadius={'4px'}>
                        <Grid mb={'20px'}>
                            <Typography variant='h6' fontWeight={700}>اگر</Typography>
                            <SelectWithSerch options={options} flag={true} />
                        </Grid>
                        <Grid mb={marginCondition} display={currentPage.includes('/setting/conditional/show-and-hide') ? 'block' : 'none'}>
                            <Typography variant='h6' fontWeight={700}>وضعیت</Typography>
                            <PassOption selectedOption={selectedOption} name={'StateCondition'} onSelectChange={handleSelectChange} placeholder={'لطفا جستجو یا انتخاب کنید ...'} multi={false} search={true} />
                        </Grid>
                        <Grid mb={marginCondition} display={currentPage.includes('/setting/conditional/update-calculate') ? 'block' : 'none'}>
                            <Typography variant='h6' fontWeight={700}>وضعیت</Typography>
                            <PassOption selectedOption={selectedOption} name={'StateConditionUpdateAndCalculate'} onSelectChange={handleSelectChange} placeholder={'لطفا جستجو یا انتخاب کنید ...'} multi={false} search={true} />
                        </Grid>
                        <Grid mb={marginCondition} display={currentPage.includes('/setting/conditional/enable-require') ? 'block' : 'none'}>
                            <Typography variant='h6' fontWeight={700}>وضعیت</Typography>
                            <PassOption selectedOption={selectedOption} name={'StateConditionEnableAndRequire'} onSelectChange={handleSelectChange} placeholder={'لطفا جستجو یا انتخاب کنید ...'} multi={false} search={true} />
                        </Grid>
                        <Grid mb={marginCondition} display={currentPage.includes('/setting/conditional/thankyou') ? 'block' : 'none'}>
                            <Typography variant='h6' fontWeight={700}>وضعیت</Typography>
                            <PassOption selectedOption={selectedOption} name={'StateConditionThankYou'} onSelectChange={handleSelectChange} placeholder={'لطفا جستجو یا انتخاب کنید ...'} multi={false} search={true} />
                        </Grid>
                        <Grid mb={marginCondition} display={currentPage.includes('/setting/conditional/skip') ? 'block' : 'none'}>
                            <Typography variant='h6' fontWeight={700}>وضعیت</Typography>
                            <PassOption selectedOption={selectedOption} name={'StateConditionSkip'} onSelectChange={handleSelectChange} placeholder={'لطفا جستجو یا انتخاب کنید ...'} multi={false} search={true} />
                        </Grid>
                        <Grid mb={marginCondition} display={currentPage.includes('/setting/conditional/email-recipient') ? 'block' : 'none'}>
                            <Typography variant='h6' fontWeight={700}>وضعیت</Typography>
                            <PassOption selectedOption={selectedOption} name={'StateConditionEmail'} onSelectChange={handleSelectChange} placeholder={'لطفا جستجو یا انتخاب کنید ...'} multi={false} search={true} />
                        </Grid>
                        <Grid display={show ? 'block' : 'none'}>
                            <Typography variant='h6' fontWeight={700}>هدف</Typography>
                            <Grid mb={'20px'} display={currentPage.includes('/setting/conditional/show-and-hide') ? 'block' : 'none'}>
                                <FormSettingSelect options={targetStatus} id={0} name={'TargetStatus'} onSelectChange={handleSelectChange} multi={false} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                            </Grid>
                            <Grid mb={'20px'} display={currentPage.includes('/setting/conditional/update-calculate') ? 'block' : 'none'}>
                                <FormSettingSelect options={targetStatus} id={0} name={'TargetStatusUpdateAndCalculate'} onSelectChange={handleSelectChange} multi={false} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                            </Grid>
                            <Grid mb={'20px'} display={currentPage.includes('/setting/conditional/enable-require') ? 'block' : 'none'}>
                                <FormSettingSelect options={targetStatus} id={0} name={'TargetStatusEnableAndRequire'} onSelectChange={handleSelectChange} multi={false} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                            </Grid>
                            <Grid mb={'20px'} display={currentPage.includes('/setting/conditional/thankyou') ? 'block' : 'none'}>
                                <FormSettingSelect options={targetStatus} id={0} name={'TargetStatusThankYou'} onSelectChange={handleSelectChange} multi={false} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                            </Grid>
                            <Grid mb={'20px'} display={currentPage.includes('/setting/conditional/skip') ? 'block' : 'none'}>
                                <FormSettingSelect options={targetStatus} id={0} name={'TargetStatusSkip'} onSelectChange={handleSelectChange} multi={false} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                            </Grid>
                            <Grid display={showTarget ? 'block' : 'none'}>
                                <Typography variant='h6' fontWeight={700}>مقدار</Typography>
                                <Grid display={currentPage.includes('/setting/conditional/show-and-hide') ? 'block' : 'none'}>
                                    <input
                                        onChange={(e) => { handleChangeValue(e, 'valueCondition') }}
                                        onBlur={() => { handleSelectChange('valueCondition', conditionValue) }}
                                        value={conditionValue}
                                        placeholder='لطفا مقدار را اینجا تایپ کنید'
                                        style={{
                                            width: '100%',
                                            padding: '8px',
                                            border: '1px solid #ced4da',
                                            borderRadius: '4px'
                                        }}
                                    />
                                </Grid>
                                <Grid display={currentPage.includes('/setting/conditional/update-calculate') ? 'block' : 'none'}>
                                    <input
                                        onChange={(e) => { handleChangeValue(e, 'valueConditionUpdateAndCalculate') }}

                                        onBlur={() => { handleSelectChange('valueConditionUpdateAndCalculate', conditionValue) }}
                                        value={conditionValue}
                                        placeholder='لطفا مقدار را اینجا تایپ کنید'
                                        style={{
                                            width: '100%',
                                            padding: '8px',
                                            border: '1px solid #ced4da',
                                            borderRadius: '4px'
                                        }}
                                    />
                                </Grid>
                                <Grid display={currentPage.includes('/setting/conditional/enable-require') ? 'block' : 'none'}>
                                    <input
                                        onChange={(e) => { handleChangeValue(e, 'valueConditionEnableAndRequire') }}

                                        onBlur={() => { handleSelectChange('valueConditionEnableAndRequire', conditionValue) }}
                                        value={conditionValue}
                                        placeholder='لطفا مقدار را اینجا تایپ کنید'
                                        style={{
                                            width: '100%',
                                            padding: '8px',
                                            border: '1px solid #ced4da',
                                            borderRadius: '4px'
                                        }}
                                    />
                                </Grid>
                                <Grid display={currentPage.includes('/setting/conditional/thankyou') ? 'block' : 'none'}>
                                    <input
                                        onChange={(e) => { handleChangeValue(e, 'valueConditionThankYou') }}

                                        onBlur={() => { handleSelectChange('valueConditionThankYou', conditionValue) }}
                                        value={conditionValue}
                                        placeholder='لطفا مقدار را اینجا تایپ کنید'
                                        style={{
                                            width: '100%',
                                            padding: '8px',
                                            border: '1px solid #ced4da',
                                            borderRadius: '4px'
                                        }}
                                    />
                                </Grid>
                                <Grid display={currentPage.includes('/setting/conditional/skip') ? 'block' : 'none'}>
                                    <input
                                        onChange={(e) => { handleChangeValue(e, 'valueConditionSkip') }}

                                        onBlur={() => { handleSelectChange('valueConditionSkip', conditionValue) }}
                                        value={conditionValue}
                                        placeholder='لطفا مقدار را اینجا تایپ کنید'
                                        style={{
                                            width: '100%',
                                            padding: '8px',
                                            border: '1px solid #ced4da',
                                            borderRadius: '4px'
                                        }}
                                    />
                                </Grid>

                            </Grid>
                            <Grid display={showTarget ? 'none' : 'block'}>
                                <Typography variant='h6' fontWeight={700}>فیلد</Typography>
                                <Grid display={currentPage.includes('/setting/conditional/show-and-hide') ? 'block' : 'none'}>
                                    <FormSettingSelect options={filterPassTitle} flag={false} onSelectChange={handleSelectChange} multi={false} name={'ifFieldCondition'} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                                </Grid>
                                <Grid display={currentPage.includes('/setting/conditional/update-calculate') ? 'block' : 'none'}>
                                    <FormSettingSelect options={filterPassTitle} flag={false} onSelectChange={handleSelectChange} multi={false} name={'ifFieldConditionUpdateAndCalculate'} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                                </Grid>
                                <Grid display={currentPage.includes('/setting/conditional/enable-require') ? 'block' : 'none'}>
                                    <FormSettingSelect options={filterPassTitle} flag={false} onSelectChange={handleSelectChange} multi={false} name={'ifFieldConditionEnableAndRequire'} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                                </Grid>
                                <Grid display={currentPage.includes('/setting/conditional/thankyou') ? 'block' : 'none'}>
                                    <FormSettingSelect options={filterPassTitle} flag={false} onSelectChange={handleSelectChange} multi={false} name={'ifFieldConditionThankYou'} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                                </Grid>
                                <Grid display={currentPage.includes('/setting/conditional/skip') ? 'block' : 'none'}>
                                    <FormSettingSelect options={filterPassTitle} flag={false} onSelectChange={handleSelectChange} multi={false} name={'ifFieldConditionSkip'} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid className='Do'>
                    <Grid mb={'8px'} width={flag ? '32px' : '0px'} height={flag ? '32px' : '0px'} borderRadius={'4px'} bgcolor={flag ? '#0075e3' : 'transparent'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                        <AddIcon style={{ color: flag ? 'white' : 'transparent' }} fontSize='large' />
                    </Grid>
                    <Grid width={'100%'} p={'24px 16px'} bgcolor={'white'} borderRight={`7px solid ${color}`} borderTop={'1px solid #c8ceed'} borderLeft={'1px solid #c8ceed'} borderBottom={'1px solid #c8ceed'} borderRadius={'4px'}>
                        <Grid mb={'20px'}>
                            <Typography variant='h6' fontWeight={700}>{emialFlag ? 'ارسال' : 'انجام دادن'}</Typography>
                            <Grid display={currentPage.includes('/setting/conditional/show-and-hide') ? 'block' : 'none'}>
                                <FormSettingSelect placeholder={emialFlag ? 'ایمیل را انتخاب کنید' : 'عملیات را انتخاب کنید'} options={renderView()} id={0} name={'DoCondition'} onSelectChange={handleSelectChange} multi={condition} search={true} />
                            </Grid>
                            <Grid display={currentPage.includes('/setting/conditional/update-calculate') ? 'block' : 'none'}>
                                <FormSettingSelect placeholder={emialFlag ? 'ایمیل را انتخاب کنید' : 'عملیات را انتخاب کنید'} options={renderView()} id={0} name={'DoConditionUpdateAndCalculate'} onSelectChange={handleSelectChange} multi={false} search={true} />
                            </Grid>
                            <Grid display={currentPage.includes('/setting/conditional/enable-require') ? 'block' : 'none'}>
                                <FormSettingSelect placeholder={emialFlag ? 'ایمیل را انتخاب کنید' : 'عملیات را انتخاب کنید'} options={renderView()} id={0} name={'DoConditionEnableAndRequire'} onSelectChange={handleSelectChange} multi={false} search={true} />
                            </Grid>
                            <Grid display={currentPage.includes('/setting/conditional/thankyou') ? 'block' : 'none'}>
                                <FormSettingSelect placeholder={emialFlag ? 'ایمیل را انتخاب کنید' : 'عملیات را انتخاب کنید'} options={renderView()} id={0} name={'DoConditionThankYou'} onSelectChange={handleSelectChange} multi={false} search={true} />
                            </Grid>
                            <Grid display={currentPage.includes('/setting/conditional/skip') ? 'block' : 'none'}>
                                <FormSettingSelect placeholder={emialFlag ? 'ایمیل را انتخاب کنید' : 'عملیات را انتخاب کنید'} options={renderView()} id={0} name={'DoConditionSkip'} onSelectChange={handleSelectChange} multi={false} search={true} />
                            </Grid>
                        </Grid>
                        <Grid mb={'20px'} display={fieldFlag ? 'block' : 'none'}>
                            <Typography variant='h6' fontWeight={700}>{emialFlag ? 'ایمیل' : value}</Typography>
                            <Grid width={'100%'} display={emialFlag ? 'none' : 'block'}>
                                <Grid display={currentPage.includes('/setting/conditional/show-and-hide') ? 'block' : 'none'}>
                                    <FormSettingSelect placeholder={placeholder} options={updateTitle} id={0} name={'FieldCondition'} onSelectChange={handleSelectChange} search={true} multi={condition} />
                                </Grid>
                                <Grid display={currentPage.includes('/setting/conditional/update-calculate') ? 'block' : 'none'}>
                                    <FormSettingSelect placeholder={placeholder} options={updateTitle} id={0} name={'FieldConditionUpdateAndCalculate'} onSelectChange={handleSelectChange} search={true} multi={condition} />
                                </Grid>
                                <Grid display={currentPage.includes('/setting/conditional/enable-require') ? 'block' : 'none'}>
                                    <FormSettingSelect placeholder={placeholder} options={updateTitle} id={0} name={'FieldConditionEnableAndRequire'} onSelectChange={handleSelectChange} search={true} multi={condition} />
                                </Grid>
                                <Grid display={currentPage.includes('/setting/conditional/thankyou') ? 'block' : 'none'}>
                                    <FormSettingSelect placeholder={placeholder} options={updateTitle} id={0} name={'FieldConditionThankYou'} onSelectChange={handleSelectChange} search={true} multi={condition} />
                                </Grid>
                                <Grid display={currentPage.includes('/setting/conditional/thankyou') ? 'block' : 'none'}>
                                    <FormSettingSelect placeholder={placeholder} options={updateTitle} id={0} name={'FieldConditionSkip'} onSelectChange={handleSelectChange} search={true} multi={condition} />
                                </Grid>
                            </Grid>
                            <Grid width={'100%'} display={emialFlag ? 'block' : 'none'}>
                                <input
                                    onChange={handleChangeEmailValue}
                                    onBlur={() => { handleSelectChange('emailValue', emailValue) }}
                                    value={conditionValue}
                                    placeholder='لطفا مقدار را اینجا تایپ کنید'
                                    style={{
                                        width: '100%',
                                        padding: '8px',
                                        border: '1px solid #ced4da',
                                        borderRadius: '4px'
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid display={currentPage.includes('/setting/conditional/update-calculate') && selectValues[DoConditionUpdateAndCalculateIndex].value !== 'محاسبه مقدار فیلد' ? 'block' : 'none'} mb={'20px'}>
                            <Typography variant='h6' fontWeight={700}>{selectValues[selectValues.findIndex(item => item.name === "DoConditionUpdateAndCalculate")].value === "کپی مقدار فیلد" ? "از" : "فیلدها"}</Typography>
                            <Grid width={'100%'}>
                                <FormSettingSelect placeholder={emialFlag ? 'لطفا آدرس ایمیل خود را بنویسید' : placeholder} options={updateTitle} id={0} name={'FieldConditionUpdateAndCalculate'} onSelectChange={handleSelectChange} search={true} multi={selectValues[3].value === "کپی مقدار فیلد" ? false : true} />
                            </Grid>
                        </Grid>
                        <Grid display={currentPage.includes('/setting/conditional/update-calculate') && selectValues[DoConditionUpdateAndCalculateIndex].value !== 'محاسبه مقدار فیلد' ? 'block' : 'none'} mb={'20px'}>
                            <Typography variant='h6' fontWeight={700}>{selectValues[selectValues.findIndex(item => item.name === "DoConditionUpdateAndCalculate")].value !== 'چندین مقدار فیلد را کپی کنید' ? "به" : "نتیجه"}</Typography>
                            <Grid width={'100%'}>
                                <FormSettingSelect placeholder={emialFlag ? 'لطفا آدرس ایمیل خود را بنویسید' : placeholder} options={updateTitle} id={0} name={'FieldConditionUpdateAndCalculate'} onSelectChange={handleSelectChange} search={true} multi={false} />
                            </Grid>
                        </Grid>
                        <Grid display={currentPage.includes('/setting/conditional/skip') ? 'block' : 'none'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='h6' fontWeight={700}>{"صفحه"}</Typography>
                            <Grid width={'100%'}>
                                <FormSettingSelect placeholder={emialFlag ? 'لطفا آدرس ایمیل خود را بنویسید' : placeholder} options={pageOption} id={0} name={'FieldConditionSkip'} onSelectChange={handleSelectChange} search={true} multi={false} />
                            </Grid>
                        </Grid>
                        <Grid display={currentPage.includes('/setting/conditional/thankyou') && selectValues[selectValues.findIndex(item => item.name === "DoConditionThankYou")].value === "نمایش پیام سفارشی" ? 'block' : 'none'}>
                            {/* <ThankYouEditor src={src} id={id} conditionFlag={true} /> */}
                            <ThankYouConditionEditor handleSelectChange={handleSelectChange}/>
                        </Grid>
                        <Grid display={currentPage.includes('/setting/conditional/thankyou') && selectValues[selectValues.findIndex(item => item.name === "DoConditionThankYou")].value === "هدایت به URL" ? 'flex' : 'none'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='h6' fontWeight={700}>{"آدرس اینترنتی"}</Typography>
                            <input
                                onChange={handleChangeUrlValue}
                                onBlur={() => { handleSelectChange('urlValue', urlValue) }}
                                value={urlValue}
                                placeholder='لطفا مقدار را اینجا تایپ کنید'
                                style={{
                                    width: '100%',
                                    padding: '8px',
                                    border: '1px solid #ced4da',
                                    borderRadius: '4px'
                                }}
                            />
                            {errorMessage !== '' && urlValue !== '' && <Typography variant='subtitle1' color={'#F5004F'} fontWeight={700}>{errorMessage}</Typography>}
                        </Grid>
                        <Grid display={currentPage.includes('/setting/conditional/update-calculate') && selectValues[DoConditionUpdateAndCalculateIndex].value === 'محاسبه مقدار فیلد' ? 'flex' : 'none'}>
                            <Calculator />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid className='DesktopShowAndHide`Condition' display={{ xs: 'none', xxs: 'block' }}>
                <Grid className='IF' mb={'16px'} display={'flex'} alignItems={'center'} flexDirection={'row-reverse'} gap={'8px'}>
                    <Grid width={'32px'} height={'32px'} borderRadius={'4px'} bgcolor={'#0075e3'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                        <AddIcon style={{ color: 'white' }} fontSize='large' />
                    </Grid>
                    <Grid width={'100%'} p={'24px 16px'} bgcolor={'white'} borderRight={`7px solid ${color}`} borderTop={'1px solid #c8ceed'} borderLeft={'1px solid #c8ceed'} borderBottom={'1px solid #c8ceed'} borderRadius={'4px'}>
                        <Grid mb={'20px'} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='h6' fontWeight={700}>اگر</Typography>
                            <SelectWithSerch options={options} />
                        </Grid>
                        <Grid mb={marginCondition} display={currentPage.includes('/setting/conditional/show-and-hide') ? 'flex' : 'none'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='h6' fontWeight={700}>وضعیت</Typography>
                            <Grid width={'70%'}>
                                <PassOption selectedOption={selectedOption} name={'StateCondition'} onSelectChange={handleSelectChange} placeholder={'لطفا جستجو یا انتخاب کنید ...'} multi={false} search={true} />
                            </Grid>
                        </Grid>
                        <Grid mb={marginCondition} display={currentPage.includes('/setting/conditional/update-calculate') ? 'flex' : 'none'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='h6' fontWeight={700}>وضعیت</Typography>
                            <Grid width={'70%'}>
                                <PassOption selectedOption={selectedOption} name={'StateConditionUpdateAndCalculate'} onSelectChange={handleSelectChange} placeholder={'لطفا جستجو یا انتخاب کنید ...'} multi={false} search={true} />
                            </Grid>
                        </Grid>
                        <Grid mb={marginCondition} display={currentPage.includes('/setting/conditional/enable-require') ? 'flex' : 'none'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='h6' fontWeight={700}>وضعیت</Typography>
                            <Grid width={'70%'}>
                                <PassOption selectedOption={selectedOption} name={'StateConditionEnableAndRequire'} onSelectChange={handleSelectChange} placeholder={'لطفا جستجو یا انتخاب کنید ...'} multi={false} search={true} />
                            </Grid>
                        </Grid>
                        <Grid mb={marginCondition} display={currentPage.includes('/setting/conditional/thankyou') ? 'flex' : 'none'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='h6' fontWeight={700}>وضعیت</Typography>
                            <Grid width={'70%'}>
                                <PassOption selectedOption={selectedOption} name={"StateConditionThankYou"} onSelectChange={handleSelectChange} placeholder={'لطفا جستجو یا انتخاب کنید ...'} multi={false} search={true} />
                            </Grid>
                        </Grid>
                        <Grid mb={marginCondition} display={currentPage.includes('/setting/conditional/skip') ? 'flex' : 'none'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='h6' fontWeight={700}>وضعیت</Typography>
                            <Grid width={'70%'}>
                                <PassOption selectedOption={selectedOption} name={"StateConditionSkip"} onSelectChange={handleSelectChange} placeholder={'لطفا جستجو یا انتخاب کنید ...'} multi={false} search={true} />
                            </Grid>
                        </Grid>
                        <Grid mb={marginCondition} display={currentPage.includes('/setting/conditional/email-recipient') ? 'flex' : 'none'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='h6' fontWeight={700}>وضعیت</Typography>
                            <Grid width={'70%'}>
                                <PassOption selectedOption={selectedOption} name={"StateConditionEmail"} onSelectChange={handleSelectChange} placeholder={'لطفا جستجو یا انتخاب کنید ...'} multi={false} search={true} />
                            </Grid>
                        </Grid>
                        <Grid display={show ? 'flex' : 'none'} alignItems={'center'} justifyContent={'space-between'} mb={'20px'}>
                            <Typography variant='h6' fontWeight={700}>هدف</Typography>
                            <Grid width={'70%'} display={currentPage.includes('/setting/conditional/show-and-hide') ? 'block' : 'none'}>
                                <FormSettingSelect options={targetStatus} id={0} name={'TargetStatus'} onSelectChange={handleSelectChange} multi={false} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                            </Grid>
                            <Grid width={'70%'} display={currentPage.includes('/setting/conditional/update-calculate') ? 'block' : 'none'}>
                                <FormSettingSelect options={targetStatus} id={0} name={'TargetStatusUpdateAndCalculate'} onSelectChange={handleSelectChange} multi={false} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                            </Grid>
                            <Grid width={'70%'} display={currentPage.includes('/setting/conditional/enable-require') ? 'block' : 'none'}>
                                <FormSettingSelect options={targetStatus} id={0} name={'TargetStatusEnableAndRequire'} onSelectChange={handleSelectChange} multi={false} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                            </Grid>
                            <Grid width={'70%'} display={currentPage.includes('/setting/conditional/thankyou') ? 'block' : 'none'}>
                                <FormSettingSelect options={targetStatus} id={0} name={'TargetStatusThankYou'} onSelectChange={handleSelectChange} multi={false} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                            </Grid>
                            <Grid width={'70%'} display={currentPage.includes('/setting/conditional/skip') ? 'block' : 'none'}>
                                <FormSettingSelect options={targetStatus} id={0} name={'TargetStatusSkip'} onSelectChange={handleSelectChange} multi={false} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                            </Grid>
                            <Grid width={'70%'} display={currentPage.includes('/setting/conditional/email-recipient') ? 'block' : 'none'}>
                                <FormSettingSelect options={targetStatus} id={0} name={'TargetStatusEmail'} onSelectChange={handleSelectChange} multi={false} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                            </Grid>
                        </Grid>
                        <Grid display={show ? 'block' : 'none'}>
                            <Grid display={showTarget ? 'flex' : 'none'} alignItems={'center'} justifyContent={'space-between'}>
                                <Typography variant='h6' fontWeight={700}>مقدار</Typography>
                                <Grid width={'70%'} display={currentPage.includes('/setting/conditional/show-and-hide') ? 'block' : 'none'}>
                                    <input
                                        onChange={(e) => { handleChangeValue(e, 'valueCondition') }}

                                        onBlur={() => { handleSelectChange('valueCondition', conditionValue) }}
                                        value={conditionValue}
                                        placeholder='لطفا مقدار را اینجا تایپ کنید'
                                        style={{
                                            width: '100%',
                                            padding: '8px',
                                            border: '1px solid #ced4da',
                                            borderRadius: '4px'
                                        }}
                                    />
                                </Grid>
                                <Grid width={'70%'} display={currentPage.includes('/setting/conditional/update-calculate') ? 'block' : 'none'}>
                                    <input
                                        onChange={(e) => { handleChangeValue(e, 'valueConditionUpdateAndCalculate') }}

                                        onBlur={() => { handleSelectChange('valueConditionUpdateAndCalculate', conditionValue) }}
                                        value={conditionValue}
                                        placeholder='لطفا مقدار را اینجا تایپ کنید'
                                        style={{
                                            width: '100%',
                                            padding: '8px',
                                            border: '1px solid #ced4da',
                                            borderRadius: '4px'
                                        }}
                                    />
                                </Grid>
                                <Grid width={'70%'} display={currentPage.includes('/setting/conditional/enable-require') ? 'flex' : 'none'}>
                                    <input
                                        onChange={(e) => { handleChangeValue(e, 'valueConditionEnableAndRequire') }}

                                        onBlur={() => { handleSelectChange('valueConditionEnableAndRequire', conditionValue) }}
                                        value={conditionValue}
                                        placeholder='لطفا مقدار را اینجا تایپ کنید'
                                        style={{
                                            width: '100%',
                                            padding: '8px',
                                            border: '1px solid #ced4da',
                                            borderRadius: '4px'
                                        }}
                                    />
                                </Grid>
                                <Grid width={'70%'} display={currentPage.includes('/setting/conditional/thankyou') ? 'flex' : 'none'}>
                                    <input
                                        onChange={(e) => { handleChangeValue(e, 'valueConditionThankYou') }}

                                        onBlur={() => { handleSelectChange('valueConditionThankYou', conditionValue) }}
                                        value={conditionValue}
                                        placeholder='لطفا مقدار را اینجا تایپ کنید'
                                        style={{
                                            width: '100%',
                                            padding: '8px',
                                            border: '1px solid #ced4da',
                                            borderRadius: '4px'
                                        }}
                                    />
                                </Grid>
                                <Grid width={'70%'} display={currentPage.includes('/setting/conditional/skip') ? 'flex' : 'none'}>
                                    <input
                                        onChange={(e) => { handleChangeValue(e, 'valueConditionSkip') }}

                                        onBlur={() => { handleSelectChange('valueConditionSkip', conditionValue) }}
                                        value={conditionValue}
                                        placeholder='لطفا مقدار را اینجا تایپ کنید'
                                        style={{
                                            width: '100%',
                                            padding: '8px',
                                            border: '1px solid #ced4da',
                                            borderRadius: '4px'
                                        }}
                                    />
                                </Grid>
                                <Grid width={'70%'} display={currentPage.includes('/setting/conditional/email-recipient') ? 'flex' : 'none'}>
                                    <input
                                        onChange={(e) => { handleChangeValue(e, 'valueConditionEmail') }}

                                        onBlur={() => { handleSelectChange('valueConditionEmail', conditionValue) }}
                                        value={conditionValue}
                                        placeholder='لطفا مقدار را اینجا تایپ کنید'
                                        style={{
                                            width: '100%',
                                            padding: '8px',
                                            border: '1px solid #ced4da',
                                            borderRadius: '4px'
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid display={showTarget ? 'none' : 'flex'} alignItems={'center'} justifyContent={'space-between'}>
                                <Typography variant='h6' fontWeight={700}>فیلد</Typography>
                                <Grid width={'70%'} display={currentPage.includes('/setting/conditional/show-and-hide') ? 'block' : 'none'}>
                                    <FormSettingSelect options={filterPassTitle} flag={false} onSelectChange={handleSelectChange} multi={false} name={'ifFieldCondition'} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                                </Grid>
                                <Grid width={'70%'} display={currentPage.includes('/setting/conditional/update-calculate') ? 'block' : 'none'}>
                                    <FormSettingSelect options={filterPassTitle} flag={false} onSelectChange={handleSelectChange} multi={false} name={'ifFieldConditionUpdateAndCalculate'} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                                </Grid>
                                <Grid width={'70%'} display={currentPage.includes('/setting/conditional/enable-require') ? 'block' : 'none'}>
                                    <FormSettingSelect options={filterPassTitle} flag={false} onSelectChange={handleSelectChange} multi={false} name={'ifFieldConditionEnableAndRequire'} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                                </Grid>
                                <Grid width={'70%'} display={currentPage.includes('/setting/conditional/thankyou') ? 'block' : 'none'}>
                                    <FormSettingSelect options={filterPassTitle} flag={false} onSelectChange={handleSelectChange} multi={false} name={'ifFieldConditionThankYou'} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                                </Grid>
                                <Grid width={'70%'} display={currentPage.includes('/setting/conditional/skip') ? 'block' : 'none'}>
                                    <FormSettingSelect options={filterPassTitle} flag={false} onSelectChange={handleSelectChange} multi={false} name={'ifFieldConditionSkip'} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                                </Grid>
                                <Grid width={'70%'} display={currentPage.includes('/setting/conditional/email-recipient') ? 'block' : 'none'}>
                                    <FormSettingSelect options={filterPassTitle} flag={false} onSelectChange={handleSelectChange} multi={false} name={'ifFieldConditionEmail'} search={true} placeholder={'لطفا جستجو یا انتخاب کنید ...'} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid className='Do' display={'flex'} alignItems={'center'} flexDirection={'row-reverse'} gap={'8px'}>
                    <Grid width={'32px'} height={'32px'} borderRadius={'4px'} bgcolor={flag ? '#0075e3' : 'transparent'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                        <AddIcon style={{ color: flag ? 'white' : 'transparent' }} fontSize='large' />
                    </Grid>
                    <Grid width={'100%'} p={'24px 16px'} bgcolor={'white'} borderRight={`7px solid ${color}`} borderTop={'1px solid #c8ceed'} borderLeft={'1px solid #c8ceed'} borderBottom={'1px solid #c8ceed'} borderRadius={'4px'}>
                        <Grid display={'flex'} alignItems={'center'} justifyContent={'space-between'} mb={currentPage === '/setting/conditional/thankyou' && selectValues[selectValues.findIndex(item => item.name === "DoConditionThankYou")]?.value === "نمایش پیام سفارشی" ? '100px' : '20px'}>
                            <Typography variant='h6' fontWeight={700}>{emialFlag ? 'ارسال' : 'انجام دادن'}</Typography>
                            <Grid width={'70%'} display={currentPage.includes('/setting/conditional/show-and-hide') ? 'block' : 'none'}>
                                <FormSettingSelect placeholder={emialFlag ? 'ایمیل را انتخاب کنید' : 'عملیات را انتخاب کنید'} options={renderView()} id={0} name={'DoCondition'} onSelectChange={handleSelectChange} multi={false} search={true} />
                            </Grid>
                            <Grid width={'70%'} display={currentPage.includes('/setting/conditional/update-calculate') ? 'block' : 'none'}>
                                <FormSettingSelect placeholder={emialFlag ? 'ایمیل را انتخاب کنید' : 'عملیات را انتخاب کنید'} options={renderView()} id={0} name={'DoConditionUpdateAndCalculate'} onSelectChange={handleSelectChange} multi={false} search={true} />
                            </Grid>
                            <Grid width={'70%'} display={currentPage.includes('/setting/conditional/enable-require') ? 'block' : 'none'}>
                                <FormSettingSelect placeholder={emialFlag ? 'ایمیل را انتخاب کنید' : 'عملیات را انتخاب کنید'} options={renderView()} id={0} name={'DoConditionEnableAndRequire'} onSelectChange={handleSelectChange} multi={false} search={true} />
                            </Grid>
                            <Grid width={'70%'} display={currentPage.includes('/setting/conditional/thankyou') ? 'block' : 'none'}>
                                <FormSettingSelect placeholder={emialFlag ? 'ایمیل را انتخاب کنید' : 'عملیات را انتخاب کنید'} options={renderView()} id={0} name={'DoConditionThankYou'} onSelectChange={handleSelectChange} multi={false} search={true} />
                            </Grid>
                            <Grid width={'70%'} display={currentPage.includes('/setting/conditional/skip') ? 'block' : 'none'}>
                                <FormSettingSelect placeholder={emialFlag ? 'ایمیل را انتخاب کنید' : 'عملیات را انتخاب کنید'} options={renderView()} id={0} name={'DoConditionSkip'} onSelectChange={handleSelectChange} multi={false} search={true} />
                            </Grid>
                            <Grid width={'70%'} display={currentPage.includes('/setting/conditional/email-recipient') ? 'block' : 'none'}>
                                <FormSettingSelect placeholder={emialFlag ? 'ایمیل را انتخاب کنید' : 'عملیات را انتخاب کنید'} options={renderView()} id={0} name={'DoConditionEmail'} onSelectChange={handleSelectChange} multi={false} search={true} />
                            </Grid>
                        </Grid>
                        <Grid display={fieldFlag ? 'flex' : 'none'} alignItems={'center'} justifyContent={'space-between'} mb={mbFlag ? '20px' : '0px'}>
                            <Typography variant='h6' fontWeight={700}>{emialFlag ? 'ایمیل' : value}</Typography>
                            <Grid width={'70%'} display={currentPage.includes('/setting/conditional/show-and-hide') && !emialFlag ? 'block' : 'none'}>
                                <FormSettingSelect placeholder={placeholder} options={updateTitle} id={0} name={'FieldCondition'} onSelectChange={handleSelectChange} search={true} multi={condition} />
                            </Grid>
                            <Grid width={'70%'} display={currentPage.includes('/setting/conditional/update-calculate') && !emialFlag ? 'block' : 'none'}>
                                <FormSettingSelect placeholder={placeholder} options={updateTitle} id={0} name={'FieldConditionUpdateAndCalculate'} onSelectChange={handleSelectChange} search={true} multi={condition} />
                            </Grid>
                            <Grid width={'70%'} display={currentPage.includes('/setting/conditional/enable-require') && !emialFlag ? 'block' : 'none'}>
                                <FormSettingSelect placeholder={placeholder} options={updateTitle} id={0} name={'FieldConditionEnableAndRequire'} onSelectChange={handleSelectChange} search={true} multi={condition} />
                            </Grid>
                            <Grid width={'70%'} display={currentPage.includes('/setting/conditional/thankyou') && !emialFlag ? 'block' : 'none'}>
                                <FormSettingSelect placeholder={placeholder} options={updateTitle} id={0} name={'FieldConditionThankYou'} onSelectChange={handleSelectChange} search={true} multi={condition} />
                            </Grid>
                            <Grid width={'70%'} display={currentPage.includes('/setting/conditional/skip') && !emialFlag ? 'block' : 'none'}>
                                <FormSettingSelect placeholder={placeholder} options={updateTitle} id={0} name={'FieldConditionSkip'} onSelectChange={handleSelectChange} search={true} multi={condition} />
                            </Grid>
                            <Grid width={'70%'} display={emialFlag ? 'block' : 'none'}>
                                <input
                                    onChange={handleChangeEmailValue}
                                    onBlur={() => { handleSelectChange('emailValue', emailValue) }}
                                    value={emailValue}
                                    placeholder='لطفا مقدار را اینجا تایپ کنید'
                                    style={{
                                        width: '100%',
                                        padding: '8px',
                                        border: '1px solid #ced4da',
                                        borderRadius: '4px'
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid display={currentPage.includes('/setting/conditional/update-calculate') && selectValues[DoConditionUpdateAndCalculateIndex].value !== 'محاسبه مقدار فیلد' ? 'flex' : 'none'} alignItems={'center'} justifyContent={'space-between'} mb={mbFlag ? '20px' : '0px'}>
                            <Typography variant='h6' fontWeight={700}>{selectValues[doIndex]?.value !== 'چندین مقدار فیلد را کپی کنید' ? "از" : "فیلدها"}</Typography>
                            <Grid width={'70%'} display={selectValues[doIndex]?.value !== 'چندین مقدار فیلد را کپی کنید' ? 'block' : 'none'}>
                                <FormSettingSelect placeholder={emialFlag ? 'لطفا آدرس ایمیل خود را بنویسید' : placeholder} options={updateTitle} id={0} name={'fromValue'} onSelectChange={handleSelectChange} search={true} multi={selectValues[doIndex]?.value === "کپی مقدار فیلد" ? false : true} />
                            </Grid>
                            <Grid width={'70%'} display={selectValues[doIndex]?.value !== 'چندین مقدار فیلد را کپی کنید' ? 'none' : 'block'}>
                                <FormSettingSelect placeholder={emialFlag ? 'لطفا آدرس ایمیل خود را بنویسید' : placeholder} options={updateTitle} id={0} name={'fromValue'} onSelectChange={handleSelectChange} search={true} multi={selectValues[doIndex]?.value === "کپی مقدار فیلد" ? false : true} />
                            </Grid>
                        </Grid>
                        <Grid display={currentPage.includes('/setting/conditional/update-calculate') && selectValues[DoConditionUpdateAndCalculateIndex].value !== 'محاسبه مقدار فیلد' ? 'flex' : 'none'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='h6' fontWeight={700}>{selectValues[doIndex]?.value !== 'چندین مقدار فیلد را کپی کنید' ? "به" : "نتیجه"}</Typography>
                            <Grid width={'70%'} display={selectValues[doIndex]?.value !== 'محاسبه مقدار فیلد' ? 'block' : 'none'}>
                                <FormSettingSelect placeholder={emialFlag ? 'لطفا آدرس ایمیل خود را بنویسید' : placeholder} options={updateTitle} id={0} name={'toValue'} onSelectChange={handleSelectChange} search={true} multi={false} />
                            </Grid>
                            <Grid width={'70%'} display={selectValues[doIndex]?.value !== 'محاسبه مقدار فیلد' ? 'none' : 'block'}>
                                <FormSettingSelect placeholder={emialFlag ? 'لطفا آدرس ایمیل خود را بنویسید' : placeholder} options={updateTitle} id={0} name={'summaryValue'} onSelectChange={handleSelectChange} search={true} multi={false} />
                            </Grid>
                        </Grid>
                        <Grid display={currentPage.includes('/setting/conditional/skip') ? 'flex' : 'none'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='h6' fontWeight={700}>{"صفحه"}</Typography>
                            <Grid width={'70%'}>
                                <FormSettingSelect placeholder={emialFlag ? 'لطفا آدرس ایمیل خود را بنویسید' : placeholder} options={pageOption} id={0} name={'FieldCondition'} onSelectChange={handleSelectChange} search={true} multi={false} />
                            </Grid>
                        </Grid>
                        <Grid display={currentPage.includes('/setting/conditional/thankyou') && selectValues[selectValues.findIndex(item => item.name === "DoConditionThankYou")].value === "نمایش پیام سفارشی" ? 'block' : 'none'}>
                            {/* <ThankYouEditor src={src} id={id} conditionFlag={true} /> */}
                            <ThankYouConditionEditor handleSelectChange={handleSelectChange}/>
                        </Grid>
                        <Grid display={currentPage.includes('/setting/conditional/thankyou') && selectValues[selectValues.findIndex(item => item.name === "DoConditionThankYou")].value === "هدایت به URL" ? 'flex' : 'none'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='h6' fontWeight={700}>{"آدرس اینترنتی"}</Typography>
                            <Grid width={'70%'}>
                                <input
                                    onChange={handleChangeUrlValue}
                                    onBlur={() => { handleSelectChange('urlValue', urlValue) }}
                                    value={urlValue}
                                    placeholder='لطفا مقدار را اینجا تایپ کنید'
                                    style={{
                                        width: '100%',
                                        padding: '8px',
                                        border: '1px solid #ced4da',
                                        borderRadius: '4px'
                                    }}
                                />
                                {errorMessage !== '' && urlValue !== '' && <Typography variant='subtitle1' color={'#F5004F'} fontWeight={700}>{errorMessage}</Typography>}
                            </Grid>
                        </Grid>
                        <Grid mb={'24px'} display={currentPage.includes('/setting/conditional/update-calculate') && selectValues[DoConditionUpdateAndCalculateIndex].value === 'محاسبه مقدار فیلد' ? 'flex' : 'none'}>
                            <Calculator />
                        </Grid>
                        <Grid display={currentPage.includes('/setting/conditional/update-calculate') && selectValues[DoConditionUpdateAndCalculateIndex].value === 'محاسبه مقدار فیلد' ? 'flex' : 'none'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='h6' fontWeight={700}>{"نتیجه"}</Typography>
                            <Grid width={'70%'}>
                                <FormSettingSelect placeholder={emialFlag ? 'لطفا آدرس ایمیل خود را بنویسید' : placeholder} options={updateTitle} id={0} name={'summaryValue'} onSelectChange={handleSelectChange} search={true} multi={false} />
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
            <Button
                sx={{
                    mt: "32px",
                    borderRadius: '4px',
                    height: "40px",
                    bgcolor: 'rgba(100,178,0,1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: '48px',
                    px: '0.625rem',
                    cursor: "pointer",

                }}
                onClick={handleSaveCondition} width={{ xs: '30%', md: '15%' }} style={{ cursor: 'pointer' }}
            >
                <Typography variant='h6' color={'white'}>ذخیره</Typography>
            </Button>
        </Grid>
    )
}

export default Condition